import { render, staticRenderFns } from "./ReportLayoutModerno.vue?vue&type=template&id=ad0c4a84&scoped=true"
import script from "./ReportLayoutModerno.vue?vue&type=script&lang=js"
export * from "./ReportLayoutModerno.vue?vue&type=script&lang=js"
import style0 from "./ReportLayoutModerno.vue?vue&type=style&index=0&id=ad0c4a84&prod&lang=css"
import style1 from "./ReportLayoutModerno.vue?vue&type=style&index=1&id=ad0c4a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0c4a84",
  null
  
)

export default component.exports